import type { ChangeEvent, FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';
import { useRouter } from 'next/router';

import { Radio } from '@motorway/mw-highway-code/alpha';

import { isAccountSlug } from 'Components/Account/AccountPage.helpers';
import { DEFAULT_ACCOUNT_DATE_RANGES } from 'Components/Account/Filters/Filters.consts';
import useAccountRouter from 'Components/Account/useAccountRouter';
import cypressIds from 'Components/cypress_ids.json';
import { triggerAccountDateFilterClicked } from 'Services/analytics/events';
import { setAccountFilter } from 'Stores/AccountFiltersStore/AccountFiltersStore.helpers';
import { AccountDateRange } from 'Types/account';
import { applyCypressData } from 'Utilities/helpers';

import LocalTexts from '../../../../Filters.texts';

import styles from './DateRangeRadioGroup.module.scss';

const LocalT = new MDText(LocalTexts);

const DateRangeRadioGroup: FC = () => {
	const router = useRouter();
	const { dateRangeType, slug } = useAccountRouter();

	const onChangeHandler = ({ target: { value } }: ChangeEvent<HTMLSelectElement>) => {
		setAccountFilter(router, { dateRangeType: value as AccountDateRange });

		if (isAccountSlug(slug)) {
			triggerAccountDateFilterClicked({ filter: value, slug });
		}
	};

	return (
		<div className={styles.radioGroupContainer}>
			<h5 className={styles.heading}>{LocalT.translate(`dateRange.heading`)}</h5>
			{DEFAULT_ACCOUNT_DATE_RANGES.map((key) => (
				<Radio
					key={key}
					defaultChecked={dateRangeType === key || (!dateRangeType && key === AccountDateRange.ALL)}
					formProps={{
						input: {
							...{ ...applyCypressData(`${cypressIds.accountFilters.dateRange}-${key}`) },
							name: 'dateRange',
							onChange: onChangeHandler,
							value: key,
						},
					}}
					id={key}
					label={LocalT.translate(`dateRange.${key}`)}
				/>
			))}
		</div>
	);
};

export default DateRangeRadioGroup;
